<div class="modal fade" id="modalTutorial" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Bem-vindo ao CRM Stack</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
      </div>
      <div class="modal-body">
        <p>Organize seus clientes, atendimentos e atividades em um só lugar.</p>
        <h6>Agenda</h6>
        <p>Crie compromissos, acompanhe sua semana e vincule atividades aos atendimentos.</p>
        <h6>Tarefas</h6>
        <p>Distribua responsabilidades, acompanhe prazos, comentários e o andamento do trabalho.</p>
        <h6>CRM</h6>
        <p>Gerencie leads e clientes desde o primeiro contato até a conclusão do atendimento.</p>
      </div>
    </div>
  </div>
</div>
